import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useUserContext } from '../../../UserContext'; 
import { usePriceContext } from '../Context/PriceContext';
import { Dropdown } from 'bootstrap';
import './Nav.css';
import { extractGoogleDriveID } from '../../Utilities/GoogleIDExtractor.js';
import { formatDate } from '../../Utilities/FormatDate.js';

const NavMessage = ({ onApprove, orderClosed, onRevise, onPay })  => {
  const { paymentData, 
    setPaymentData, 
    confirmation, setConfirmation,
    message, setMessage, 
    activeMessageId, setActiveMessageId, 
    activeBalanceDue, setActiveBalanceDue,
    paymentSuccess
  } = usePriceContext();
  const { email, setEmail, googleDriveID, setGoogleDriveID } = useUserContext(); 

  const [error, setError] = useState('');
  



  const API_URL = process.env.REACT_APP_API_URL;



  useEffect(() => {
    const dropdownElement = document.querySelector('[data-bs-toggle="dropdown"]');
    if (dropdownElement) {
      new Dropdown(dropdownElement); 
    }
  }, []);

  useEffect(() => {
    const savedEmail = sessionStorage.getItem('userEmail');
    const savedGoogleDriveID = sessionStorage.getItem('googleDriveID');
  
 
    setEmail(savedEmail);
    setGoogleDriveID(savedGoogleDriveID);
  
    
  }, []);

 
  const handleNavClick = async () => {
    const fetchMessages = async () => {
      try {
        if (!email) {
          setError('Email is required');
          return;
        }
    
        console.log('Sending to backend:', email);
        const response = await axiosInstance.get(`${API_URL}/api/data/client-message`, {
          params: { 
            email: email 
        
          },
          withCredentials: true
        });
    
        console.log('Backend response:', response.data); // Check the response data
        const responseData = Array.isArray(response.data) ? response.data : [response.data];
    
        const formattedMessages = responseData.flatMap(item => {
          // Extract data from either root or orderData
          const data = item.orderData || item;
    
          return {
            _id: item._id,
            email: data.email,
            googleDriveLink: data.googleDriveLink || null,
            documentType: data.documentType || data.projectType, 
            instructions: data.instructions || null,
            files: Array.isArray(data.files) ? data.files : [],
            wordCount: data.wordCount || null,
            initialCost: data.initialCost || data.total || null,
            couponCode: data.couponCode || null, 
            balanceDue: parseFloat(
              String(data.balanceDue).replace(/[^0-9.]/g, '')
            ) || 0,
            
            preparer: data.preparer || null,
            adminMessage: data.adminMessage || 'No message available',
            orderCreate_time: formatDate(data.create_time) || null, 
            deadline: formatDate(data.deadline),
            openOrder: data.openOrder || null,
            additionalServices: data.additionalServices || null,
          };
        });
    
        setMessage(formattedMessages);
      } catch (error) {
        console.error('Error fetching messages:', error);
        setError(error.response?.data?.error ||'Failed to fetch messages');
      }
    };
    
    if (email) {
        await fetchMessages(); // Call the fetchMessages function
      } else {
        console.error('Email is missing. Cannot fetch messages.');
      }
    };

    useEffect(() => {
      const fetchData = async () => {
        if (email) {
          await handleNavClick();
        } else {
          console.error('Email is missing. Cannot fetch messages.');
        }
      };
    
      fetchData();
  }, [email, googleDriveID]); // Dependency array ensures useEffect runs when email or googleDriveID changes
    

  const handleDownload = async (filename) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/api/data/download/${filename}`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Download failed:', error);
      setError('File download failed');
    }
  };
  
  

  const handleDelete = async (messageId) => {
    try {
      await axiosInstance.delete(`${API_URL}/api/data/delete/${messageId}`);
      setMessage(message.filter(message => message._id !== messageId));
    } catch (error) {
      console.error('Error deleting message:', error);
      setError('Failed to delete message');
    }
  };

  const handleRevise = (googleDriveLink, messageId) => {
    if (messageId === activeMessageId) {
      alert('Use sticky note feature to submit your feedback.');
      return;
    }
    const googleDriveID = extractGoogleDriveID(googleDriveLink);
  
    if (googleDriveID) {
      const selectedMessage = message.find(msg => msg._id === messageId);

      setActiveMessageId(messageId);
      setActiveBalanceDue(selectedMessage?.balanceDue ?? null);
      onRevise(googleDriveID);
    } else {
      console.error('Invalid Google Drive link. Unable to extract Google Drive ID.');
    }
  };
  
  const handleApprove = (balanceDue, messageId, googleDriveLink, messageEmail) => {  
    // 2. Create payment data object
    const paymentData = {
      amount: balanceDue,  // "$390"
      messageId: messageId         // "ae33"
    };
    const googleDriveID = extractGoogleDriveID(googleDriveLink);

    if (googleDriveID) {
      const selectedMessage = message.find(msg => msg._id === messageId);
      setConfirmation(true);
      setActiveMessageId(messageId);
      setActiveBalanceDue(balanceDue);
      onApprove(paymentData, googleDriveID, messageEmail);
    }else{
      console.error('Unable to close order at this time.');
    }
  };

  const handlePay = (balanceDue, messageId) => {
    const paymentData = {
      amount: balanceDue,
      messageId: messageId
    };
    setConfirmation(true);
    setActiveMessageId(messageId);
    setActiveBalanceDue(balanceDue);
    onPay(paymentData);
  };
  

  

  return (
    <li className="nav-item dropdown">
      <a className="nav-link nav-icon" data-bs-toggle="dropdown"    onClick={handleNavClick}>
        
      <span className="badge badge-number">{message.length}</span>

      </a>
      <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages" 
     style={{
       backgroundColor: "transparent",
       boxShadow: "none",
       height: "100vh",
       position: "fixed",
       maxHeight: "80vh",
       position: "fixed",
       top: "0 !important",
       marginBottom:"55px",
       left: "auto !important",
       right: "0 !important",
       transform: "none !important",
       maxWidth: "450px",
       overflowY: "auto",
       display: "block !important",
       opacity: "1 !important",
       padding:"10px",
       pointerEvents: "auto !important"
     }}>
        {error && <div className="dropdown-header">{error}</div>}
        {message.length === 0 ? (
          <div className="dropdown-header text-danger">All orders have been <strong>CLOSED.</strong></div>
        ) : (
          message.map((msg, index) => (
            <React.Fragment key={msg._id}>
      <div className="message-container2">

        {/* DEADLINE INFO (TOP) */}
        <div className="message-deadline-row">
          {msg.openOrder && (
            <span className="message-deadline">PROCESSED {msg.openOrder} &nbsp;||&nbsp; </span>
          )}
          {msg.create_time && (
            <span className="message-deadline">ORDER SUBMITTED {msg.create_time} &nbsp;||&nbsp; </span>
          )}
          <span className="message-deadline">DEADLINE {msg.deadline}</span>
        </div>
        <span className="message-divider" />

        {/* DOCUMENT TYPE + PAYMENT + BUTTONS (ALL HORIZONTAL, NO WRAP) */}
        <div className="document-buttons-container">
          <span className="message-document-type">
            {msg.documentType} &nbsp;|&nbsp;
            {msg.initialCost 
              ? `$${msg.initialCost}`
              : `Balance Due: $${msg.balanceDue === 0 ? '0' : msg.balanceDue}`
            }
          </span>

          {msg.files?.map((filename, index) => {
            const getFileLabel = (filename) => {
              const extension = filename.split('.').pop().toLowerCase();
              
              if (['jpeg', 'jpg', 'png'].includes(extension)) {
                return 'Image';
              }
              if (extension === 'mp3') {
                return 'Audio';
              }
              if (extension === 'mp4') {
                return 'Video';
              }
              return 'Draft'; // Everything else (PDF, DOC, XLS, TXT, etc.)
            };

            return (
              <button 
                key={index}
                onClick={() => handleDownload(filename)}
                className="btn btn-draft"
              >
                {getFileLabel(filename)}
              </button>
            );
          })}
          {!(orderClosed || msg.instructions) && (
            <>
              {msg.balanceDue > 0 ? (
                <button 
                  onClick={() => handlePay(msg.balanceDue, msg._id)} 
                  className="btn btn-pay"
                >
                  Pay
                </button>
              ) : (
                <button 
                  onClick={() => handleApprove(msg.balanceDue, msg._id, msg.googleDriveLink, msg.email)} 
                  className="btn btn-remove"
                >
                  Approve
                </button>
              )}
              <button 
                onClick={() => handleRevise(msg.googleDriveLink, msg._id)}  
                className="btn btn-remove"
              >
                Review
              </button>
            </>
          )}
        </div>

        {/* ADMIN MESSAGE (BOTTOM) */}
        <div className="message-instructions-container">
          <div className="message-instructions">
            {msg.preparer 
              ? `${msg.preparer}: ${msg.adminMessage}` 
              : `${msg.email} writes: ${msg.instructions}`
            }
            &nbsp;|&nbsp;{msg.couponCode}
          </div>
        </div>

      
      </div>
    </React.Fragment>

              ))
            )}
          </div>
    </li>
  );
};

export default NavMessage;
